export default __webpack_public_path__ + "static/media/alk_mini_logo_r.0e462924.png";